var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91484 0.25V1.93963L0.521484 5.40199V19.75H22.0949V5.40199L16.7015 1.93963V0.25H5.91484ZM7.71262 2.02273H14.9038V8.83665L11.3082 11.1357L7.71262 8.83665V2.02273ZM8.61151 3.79545V5.56818H14.0049V3.79545H8.61151ZM5.91484 4.04474V7.6733L3.07771 5.87287L5.91484 4.04474ZM16.7015 4.04474L19.5387 5.87287L16.7015 7.6733V4.04474ZM8.61151 6.45455V8.22727H14.0049V6.45455H8.61151ZM2.31927 7.5071L11.3082 13.2408L20.2971 7.5071V17.9773H2.31927V7.5071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/IconEmail.1ba997c3383c646d6e26fe62bc73b768.svg";
export { ForwardRef as ReactComponent };